const returnExample = [
    {
        "count": 29
    }
]

export type totalClicksToDateReturnType = typeof returnExample

const buildTotalClicksToDate = (): any[] => [
    {
        "$group": {
            "_id": null,
            "count": {
                "$sum": 1
            }
        }
    }
]
export default buildTotalClicksToDate